var isErrorIconVisible = function isErrorIconVisible(theme, platform, showIconProp) {
  if (showIconProp !== undefined) {
    return showIconProp;
  } else {
    return theme.errorMessage[platform].icon.visible;
  }
};

export { isErrorIconVisible };
